import { render } from "./ChangeLog.vue?vue&type=template&id=1487fdb0&scoped=true"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"

import "./ChangeLog.vue?vue&type=style&index=0&id=1487fdb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1487fdb0"]])

export default __exports__